<div class="detail">
  <div class="title">我的钱包</div>
  <div class="txt1">
    您申请退款的订单将转换为账户余额，您可以使用余额购买任意服务。
  </div>
  <div class="txt2">
    <span class="label">钱包余额：</span>
    <span class="value">￥ {{ data?.wallet_balance }}</span>
  </div>
  <div class="btn" (click)="close()">我知道</div>
</div>
